import { FRENCH_DATE_FORMAT } from "@middleware/constants";
import { EFieldTypes, EGender, TGender } from "@middleware/types";

const maxDate = new Date();
maxDate.setFullYear(maxDate.getFullYear() - 2);

export const fields = (gender?: TGender) => [
  {
    type: EFieldTypes.TEXT,
    name: "name",
    class: "input-text",
    placeholder: gender === EGender.MAN ? "Charles" : "Christine",
    required: true,
  },
  {
    type: EFieldTypes.RADIO,
    name: "gender",
    class: "input-radio",
    placeholder: "",
    required: true,
    options: [
      {
        label: "bilan.women",
        value: "gender_b",
      },
      {
        label: "bilan.men",
        value: "gender_a",
      },
    ],
  },
  {
    type: EFieldTypes.DATE,
    name: "birth_date",
    class: "input-text",
    placeholder: FRENCH_DATE_FORMAT.toLowerCase(),
    required: true,
    maxDate: maxDate,
  },
  {
    type: EFieldTypes.NUMBER,
    name: "height",
    class: "input-text",
    placeholder: "160",
    required: true,
  },
  {
    type: EFieldTypes.NUMBER,
    name: "current_weight",
    class: "input-text",
    placeholder: "80",
    required: true,
  },
  {
    type: EFieldTypes.NUMBER,
    name: "desired_weight",
    class: "input-text",
    placeholder: "60",
    required: true,
  },
  {
    type: EFieldTypes.RADIO,
    name: "health_pov",
    class: "input-radio",
    required: true,
    options: [
      {
        label: "bilan.bad",
        value: "health_pov_a",
      },
      {
        label: "bilan.low",
        value: "health_pov_b",
      },
      {
        label: "bilan.satisfied",
        value: "health_pov_c",
      },
      {
        label: "bilan.good",
        value: "health_pov_d",
      },
      {
        label: "bilan.verygood",
        value: "health_pov_e",
      },
    ],
  },
  {
    type: EFieldTypes.RADIO,
    name: "activity_level",
    class: "input-radio",
    placeholder: "",
    required: true,
    options: [
      {
        label: "bilan.veryWeak",
        value: "activity_level_a",
      },
      {
        label: "bilan.weak",
        value: "activity_level_b",
      },
      {
        label: "bilan.medium",
        value: "activity_level_c",
      },
      {
        label: "bilan.satisfying",
        value: "activity_level_d",
      },
      {
        label: "bilan.high",
        value: "activity_level_e",
      },
      {
        label: "bilan.veryHigh",
        value: "activity_level_f",
      },
    ],
  },
  {
    type: EFieldTypes.RADIO,
    name: "sleep_problems",
    class: "input-radio",
    placeholder: "",
    required: true,
    options: [
      {
        label: "bilan.never",
        value: "sleep_problems_a",
      },
      {
        label: "bilan.sometimes",
        value: "sleep_problems_b",
      },
      {
        label: "bilan.often",
        value: "sleep_problems_c",
      },
      {
        label: "bilan.allTime",
        value: "sleep_problems_d",
      },
    ],
  },
  {
    type: EFieldTypes.RADIO,
    name: "morning_fatigue",
    class: "input-radio",
    placeholder: "",
    required: true,
    options: [
      {
        label: "bilan.never",
        value: "morning_fatigue_a",
      },
      {
        label: "bilan.sometimes",
        value: "morning_fatigue_b",
      },
      {
        label: "bilan.often",
        value: "morning_fatigue_c",
      },
      {
        label: "bilan.allTime",
        value: "morning_fatigue_d",
      },
    ],
  },
  {
    type: EFieldTypes.RADIO,
    name: "digestion_problems",
    class: "input-radio",
    placeholder: "",
    required: true,
    options: [
      {
        label: "bilan.never",
        value: "digestion_problems_a",
      },
      {
        label: "bilan.sometimes",
        value: "digestion_problems_b",
      },
      {
        label: "bilan.often",
        value: "digestion_problems_c",
      },
      {
        label: "bilan.allTime",
        value: "digestion_problems_d",
      },
    ],
  },
  {
    type: EFieldTypes.RADIO,
    name: "diets_number",
    class: "input-radio",
    placeholder: "",
    required: true,
    options: [
      {
        label: "0",
        value: "diets_number_a",
      },
      {
        label: "1",
        value: "diets_number_b",
      },
      {
        label: "2",
        value: "diets_number_c",
      },
      {
        label: "3",
        value: "diets_number_d",
      },
      {
        label: "bilan.moreThanThre",
        value: "diets_number_e",
      },
    ],
  },
  {
    type: EFieldTypes.EMAIL,
    name: "email",
    class: "input-text",
    placeholder:
      gender === EGender.MAN ? "charles@gmail.com" : "christine@gmail.com",
    required: true,
  },
  {
    type: EFieldTypes.TEL,
    name: "phone",
    class: "input-text",
    placeholder: "+33 6 00 00 00 00",
  },
];
